export default [{
    title: "Ventas",
    fontIcon: "file-contract",
    resource: "Ventas",
    action: "ver-ventas",
    children: [{
            title: "Dashboard",
            icon: "LayoutIcon",
            resource: "Ventas",
            action: "ver-ventas-dashboard",
            children: [{
                route: "ventas-dashboard-proyeccion",
                title: "Proyeccion",
                resource: "Ventas",
                action: "ver-ventas-dashboard-proyeccion",
            },
            {
                route: "ventas-dashboard-promociones",
                title: "Aprobacion de Promociones",
                resource: "Ventas",
                action: "ver-ventas-dashboard-promociones",
            }],
        }, {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Ventas",
            action: "ver-ventas-configuracion",
            children: [{
                route: "ventas-configuracion-proyeccion",
                title: "Presupuesto",
                resource: "Ventas",
                action: "ver-ventas-configuracion-proyeccion",
            }]
        }, {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Ventas",
            action: "ver-ventas-mantenimiento",
        }, {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Ventas",
            action: "ver-ventas-transacciones",
            children: [{
                route: "ventas-presupuesto",
                title: "Presupuesto",
                resource: "Ventas",
                action: "ver-ventas-presupuesto",
            }, {
                route: "ventas-solicitud-presupuesto",
                title: "Solicitud de Presupuesto",
                resource: "Ventas",
                action: "ver-ventas-solicitud-presupuesto",
            }, {
                route: "ventas-aprobacion-presupuesto",
                title: "Aprobacion de Solicitud de Presupuesto",
                resource: "Ventas",
                action: "ver-ventas-aprobacion-presupuesto",
            }, {
                route: "ventas-pedido-muestras",
                title: "Pedido de Cliente de Muestras",
                resource: "Ventas",
                action: "ver-ventas-pedido-muestras",
            }]
        },
        {
            title: "Informes",
            fontIcon: "file-prescription",
            resource: "Ventas",
            action: "ver-ventas-informes",
            children: [{
                route: "ventas-reporte-presupuesto",
                title: "Presupuesto",
                resource: "Ventas",
                action: "ver-ventas-reporte-presupuesto",
            }, {
                route: "ventas-reporte-cierre-mes",
                title: "Cierre de Mes",
                resource: "Ventas",
                action: "ver-ventas-reporte-cierre-mes",
            },{
                route: "ventas-reporte-proyecciones",
                title: "Proyecciones",
                resource: "Ventas",
                action: "ver-ventas-reporte-proyecciones",
            },{
                route: "ventas-reporte-proyecciones-anio",
                title: "Proyecciones por Año",
                resource: "Ventas",
                action: "ver-ventas-reporte-proyecciones-anio",
            }]
        },
    ]
}]